import { Text } from "@ttc3k/trekker";
import { styled } from "styled-system/jsx";

const OptionButton = styled("button", {
  base: {
    display: "flex",
    flexDir: "column",
    alignItems: "flex-start",
    gap: "50",
    w: "full",
    py: "150",
    px: "200",
    borderRadius: "100",
    border: "1px solid",
    borderColor: "border.light",
    outline: "1px solid",
    outlineColor: "transparent",
    bg: "ink.100",
    textAlign: "left",
    cursor: "pointer",
    transitionProperty: "border-color, outline-color",
    transitionDuration: "150ms",
    _focusVisible: { outlineColor: "border.mid" },
    _disabled: { cursor: "not-allowed", opacity: 0.6 },
  },
  variants: {
    selected: {
      true: {
        bg: "white",
        borderColor: "border.dark",
        outlineColor: "border.dark",
      },
    },
  },
});

type ChoiceOptionProps = {
  label: string;
  hint?: string;
  selected: boolean;
  disabled?: boolean;
  onSelect: () => void;
};

/** One answer in a single-choice question, with an explanation under it. */
export const ChoiceOption = ({
  label,
  hint,
  selected,
  disabled,
  onSelect,
}: ChoiceOptionProps) => (
  <OptionButton
    type="button"
    role="radio"
    aria-checked={selected}
    selected={selected}
    disabled={disabled}
    onClick={onSelect}
  >
    <Text visual="smallSemiBold" color="text.dark">
      {label}
    </Text>
    {hint && (
      <Text size="sm" color="text.mid">
        {hint}
      </Text>
    )}
  </OptionButton>
);
